import React from "react";
import styles from "./Hints.module.css";
import hintImage from "../../../assets/images/Hints/random.jpg";
import Hint from "./Hint";
import TitleH2 from "../../../components/TitleH2/TitleH2";
function Hints() {
  const hints = [
    {
      id: 1,
      title: "فعالیت اول",
      image: hintImage,
      description:
        " بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه درصد گذشته حال و ینیپ",
    },
    {
      id: 2,
      title: "فعالیت دوم",
      image: hintImage,
      description:
        "بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه درصد گذشته حال و ینی",
    },
    {
      id: 3,
      title: "فعالیت سوم",
      image: hintImage,
      description:
        "بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه درصد گذشته حال و ینی",
    },
    {
      id: 4,
      title: "فعالیت اول",
      image: hintImage,
      description:
        " بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه درصد گذشته حال و ینیپ",
    },
    {
      id: 5,
      title: "فعالیت اول",
      image: hintImage,
      description:
        " بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه درصد گذشته حال و ینیپ",
    },
    {
      id: 6,
      title: "فعالیت اول",
      image: hintImage,
      description:
        " بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه درصد گذشته حال و ینیپ",
    },
  ];

  return (
    <>
      <section
        id="homePage-hints__sec"
        className={`${styles.hintsSec} hints__cont`}>
        <TitleH2 className={``}>فعالیت‌های ما</TitleH2>
        <div className={`${styles.hints}`}>
          {hints.map((hint) => (
            <Hint
              key={hint.id}
              title={hint.title}
              image={hint.image}
              description={hint.description}
            />
          ))}
        </div>
      </section>
    </>
  );
}

export default Hints;
